import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { KTIcon } from '../../../helpers'
import { HeaderUserMenu } from '../../../partials'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { Tooltip } from 'bootstrap'

import HeaderNotificationsMenu from '../../../partials/layout/header-menus/HeaderNotificationsMenu'
import HeaderCartMenu from '../../../partials/layout/header-menus/HeaderCartMenu'

import { useAuth } from '../../../../app/modules/auth'
import PolicyChecker from '../../../../_metronic/helpers/components/PolicyChecker';
import { enumPolicies } from '../../../../_metronic/helpers';


// Same gap between every header trigger; the avatar gets a touch more room.
const NAVBAR_ITEM_SPACING = 'ms-1 ms-lg-2'

const Navbar = () => {
  const { currentUser } = useAuth()
  const intl = useIntl()

  useEffect(() => {
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new Tooltip(tooltipTriggerEl)
    })
    return function cleanup() {
      tooltipList.forEach(t => t.dispose())
    };
  }, []);

  return (
    <div className='app-navbar flex-shrink-0 flex-wrap flex-lg-nowrap align-items-center'>

      {/* Calculator Link */}
      <PolicyChecker policies={[enumPolicies.VerandaCalculatorWrite]}>
        <div className={clsx('app-navbar-item', NAVBAR_ITEM_SPACING)}>
          <Link
            to='/veranda-calculator'
            className='app-navbar-trigger'
            data-bs-toggle="tooltip"
            title={intl.formatMessage({ id: 'VERANDA_CALCULATOR.PAGE_TITLE' })}
          >
            <KTIcon iconName='calculator' className='fs-1' />
          </Link>
        </div>
      </PolicyChecker>

      {/* Notifications Menu */}
      <div className={clsx('app-navbar-item', NAVBAR_ITEM_SPACING)}>
        <HeaderNotificationsMenu />
      </div>

      {/* Cart Menu */}
      <PolicyChecker policies={[enumPolicies.OrderCheckoutRead, enumPolicies.OrderCheckoutEdit, enumPolicies.OrderCheckoutWrite]}>
        <div className={clsx('app-navbar-item', NAVBAR_ITEM_SPACING)}>
          <HeaderCartMenu />
        </div>
      </PolicyChecker>

      {/* User Menu */}
      <div className={clsx('app-navbar-item', NAVBAR_ITEM_SPACING, 'ms-lg-4')}>
        <div
          className={clsx('symbol symbol-circle symbol-40px app-navbar-avatar')}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-bs-toggle="tooltip"
          title={intl.formatMessage({ id: 'USER.HEADER.MY_PROFILE' })}
        >
          <img src={currentUser && currentUser.avatarLink} alt='' />
        </div>
        <HeaderUserMenu />
      </div>

    </div>
  )
}

export { Navbar }
